import {
  CircularProgress,
  createStyles,
  Grid,
  IconButton,
  makeStyles,
  OutlinedInput,
  Theme,
  Typography,
} from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectIsMobile } from "../../../redux/slices/cleverlynkSlice";
import { selectQueryCustomerInfo } from "../../../redux/slices/userFormSlice";

interface IAddEmail {
  confirmMail: (s: string) => void;
  invalid: boolean;
}

const AddEmail = ({ confirmMail, invalid }: IAddEmail) => {
  const isMobile = useSelector(selectIsMobile);

  const queryCustomerInfoSupervisor = useSelector(selectQueryCustomerInfo);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        maxWidth: 420,
        width: "96%",
        height: 50,
        border: "none",
        color: theme.palette.primary.contrastText,
        "& ::placeholder": {
          color: invalid ? "white" : theme.palette.primary.contrastText,
        },
        "&.invalid": {
          color: "white",
        },
      },
      notchedOutline: {
        border: "none",
      },
      circularProgress: {
        color: theme.palette.secondary.contrastText,
      },
    })
  );

  useEffect(() => {
    const elem = document.getElementById("outlined-input-email");
    if (elem) elem.focus();
  }, []);

  const classes = useStyles();

  return (
    <React.Fragment>
      <OutlinedInput
        id="outlined-input-email"
        placeholder="Ingresa tu correo"
        classes={{
          root: `${invalid ? "invalid" : ""} ${classes.root}`,
          notchedOutline: classes.notchedOutline,
        }}
      />
      <IconButton
        onClick={() => {
          const elem: any = document.getElementById("outlined-input-email");
          if (elem) confirmMail(elem.value);
        }}>
        {queryCustomerInfoSupervisor.status !== "loading" ? null : (
          <CircularProgress thickness={5} size={25} className={classes.circularProgress} />
        )}
      </IconButton>
    </React.Fragment>
  );
};
export default AddEmail;
